import Helper from "./Helper";

const Archive = {
  paged: 1,
  foundPosts: 0,
  maxNumPages: 0,
  fetchPostType: "any", // fallback post type
  inputSearch: null,
  filterForm: null,
  filterFormEntries: {}, // filter form values
  btnLoadMore: null,

  init: () => {
    // check post type archive page
    const isArchive = document.querySelector(
      "body.post-type-archive, body.search-results",
    );

    // get input search element
    Archive.inputSearch = document.getElementById("input-search");

    // get form filter element
    Archive.filterForm = document.getElementById("form-filter");

    // get load more btn
    Archive.btnLoadMore = document.getElementById("btn-load-more");

    if (!isArchive) {
      // remove load more btn
      if (Archive.btnLoadMore) Archive.btnLoadMore.remove();
      return;
    }

    console.log("Archive");

    // store filter settings
    if (Archive.filterForm) {
      // create new FormData from form element
      const filterFormData = new FormData(Archive.filterForm);

      // create obj from FormData entries
      Archive.filterFormEntries = Object.fromEntries(filterFormData);
      console.log(Archive.filterFormEntries);
    }

    // activate load more btn
    if (Archive.btnLoadMore) {
      Archive.btnLoadMore.addEventListener("click", function () {
        Archive.handleSubmit();
      });
    }

    // console.log("siteData.fetchPostType");
    // console.log(siteData.fetchPostType);

    if (siteData.fetchPostType != "")
      Archive.fetchPostType = siteData.fetchPostType;

    // console.log("Archive.fetchPostType");
    // console.log(Archive.fetchPostType);
  },

  handleSubmit: (e) => {
    console.log("fetching...");

    // disable load more btn
    Archive.btnLoadMore.setAttribute("disabled", "");

    console.log(Archive.filterFormEntries);

    // wp ajax url
    let url = siteData.ajaxUrl;

    // increment paged
    Archive.paged++;

    // prepare data
    const data = {
      action: "hemsa_next_items",
      nonce: siteData.nonce,
      paged: Archive.paged,
      fetch_post_type: Archive.fetchPostType,
      s: Archive.inputSearch ? Archive.inputSearch.value : "",
      ...Archive.filterFormEntries,
    };

    // encode data
    const query = Helper.encodeData(data);

    if (query.length) {
      url += "?" + query;
    }

    // setup fetch options
    const options = {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    };

    // fetch posts
    fetch(url, options)
      .then((res) => {
        // promise returned
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        // success
        const data = res.data;

        // get pre-rendered post items
        const items = res.data.items;

        // get posts wrapper
        const resultsWrapper = document.getElementById("results");

        if (items && items.length != -1) {
          if (resultsWrapper) {
            // render each post item to the DOM
            items.forEach((item, index) => {
              resultsWrapper.insertAdjacentHTML("beforeend", item);

              if (index === 0) {
                // set focus to first new post item
                resultsWrapper.lastChild.focus();
              }
            });
          }
        }

        // console.log("data.foundPosts: " + data.foundPosts);
        // console.log("data.maxNumPages: " + data.maxNumPages);

        // update foundPosts and maxNumPages
        Archive.foundPosts = data.foundPosts;
        Archive.maxNumPages = data.maxNumPages;

        // console.log("Archive.foundPosts: " + Archive.foundPosts);
        // console.log("Archive.maxNumPages: " + Archive.maxNumPages);

        // update btn status
        if (Archive.paged == Archive.maxNumPages || Archive.maxNumPages == 0) {
          // nothing more to load - disable button
          Archive.btnLoadMore.setAttribute("disabled", "");
          Archive.btnLoadMore.remove();
        } else {
          // were not on the last page - activate button again!
          Archive.btnLoadMore.removeAttribute("disabled");
        }
      })
      .catch((err) => {
        // error
        console.log(err);

        // update btn status
        Archive.btnLoadMore.removeAttribute("disabled");
      });
  },
};

export default Archive;
